import * as React from 'react';

const Banner = () => {
    return ( 
        <div className='banner' />
     );
}
 
export default Banner;